import { render, staticRenderFns } from "./LanguageSelection.vue?vue&type=template&id=a75759ee&"
import script from "./languageSelection.js?vue&type=script&lang=js&"
export * from "./languageSelection.js?vue&type=script&lang=js&"
import style0 from "./LanguageSelection.vue?vue&type=style&index=0&id=a75759ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports